// @flow
import { useCurrencySign } from 'app/common/components-next/currency';
import { useTranslation } from 'react-i18next';


const ids = [
  'title',
  'cost',
  'number',
  'total',
];

export const useColumns = (): Array<string> => ids;

export const useTitles = (): Array<string> => {
  const currency = useCurrencySign();
  const { t } = useTranslation('cafeteria');
  const tableHeaders = t('order_request_sales_table_columns', { returnObjects: true, currency });

  return tableHeaders;
};
